<ex-sort-dropdown [items]="sortItems"
                  [defaultValue]="sort"
                  (sort)="onSort($event)"
                  [invertArrowIcons]="sort?.field===SortFieldEnum.ESTIMATED_END_DATE"
                  [headerHeight]="inBoardView ? 32 : undefined"
                  useShortLabel
                  class="{{size}}"/>
